import { useNavigate, useParams } from 'react-router-dom'
import HerramientaForm from '@/features/almacen/components/HerramientaForm'

/**
 * Consulta y edición de una herramienta. El id viene de la ruta, y el modo lo
 * decide la ruta que monta esta página.
 *
 * `volverA` existe porque a esta pantalla se llega desde dos listados: el de
 * registro y el de asignación, y hay que regresar al que corresponde.
 */
const HerramientaPage = ({
  mode,
  volverA = '/almacen/registro',
}: {
  mode: 'view' | 'edit'
  volverA?: string
}) => {
  const navigate = useNavigate()
  const { id = '' } = useParams<{ id: string }>()

  return <HerramientaForm mode={mode} id={id} onBack={() => navigate(volverA)} />
}

export default HerramientaPage
